import React from 'react';
import { Footer } from '../components/HomePage';
import HowItWorksHeader from '../components/HowItWorks/HowItWorksHeader';
import HowItWorksSection from '../components/HowItWorks/HowItWorksSection';

function HowItWorksPage() {
  return (
    <>
      <HowItWorksHeader />
      <HowItWorksSection />
      <Footer />
    </>
  );
}

export default HowItWorksPage;